import { MachineConfig } from 'xstate/lib/types';
import {
  SIGN_UP_FLOW_STATES_NAME,
  SignUpFlowContext,
  SignUpFlowStatesSchema,
} from './signUpMachineTypes';
import { SignUpFlowEvents } from './signUpMachineEventTypes';
import {
  welcomeState,
  jobRoleState,
  teamSizeState,
  clientsChargeState,
  monthlyAdBudgetState,
  goalState,
  redirectState,
  initState,
  watchVideoOne,
  industryState,
  connectChannels,
  websiteTrafficState,
  leadsListState,
} from './signUpMachineStates';

export const signUpFlowMachineConfig: MachineConfig<
  SignUpFlowContext,
  SignUpFlowStatesSchema,
  SignUpFlowEvents
> = {
  id: 'SignUpFlow',
  initial: SIGN_UP_FLOW_STATES_NAME.INIT,
  context: {
    activeStep: 0,
    stepOptions: {
      isOtherIndustrySelected: false,
    },
    isFBUser: false,
    isNewSignupFlow: false,
  },
  states: {
    [SIGN_UP_FLOW_STATES_NAME.INIT]: initState,
    [SIGN_UP_FLOW_STATES_NAME.WELCOME]: welcomeState,
    [SIGN_UP_FLOW_STATES_NAME.JOB_ROLE]: jobRoleState,
    [SIGN_UP_FLOW_STATES_NAME.TEAM_SIZE]: teamSizeState,
    [SIGN_UP_FLOW_STATES_NAME.CLIENTS_CHARGE]: clientsChargeState,
    [SIGN_UP_FLOW_STATES_NAME.MONTHLY_AD_BUDGET]: monthlyAdBudgetState,
    [SIGN_UP_FLOW_STATES_NAME.INDUSTRY]: industryState,
    [SIGN_UP_FLOW_STATES_NAME.GOAL]: goalState,
    [SIGN_UP_FLOW_STATES_NAME.WEBSITE_TRAFFIC]: websiteTrafficState,
    [SIGN_UP_FLOW_STATES_NAME.LEADS_LIST]: leadsListState,
    [SIGN_UP_FLOW_STATES_NAME.VIDEO]: watchVideoOne,
    [SIGN_UP_FLOW_STATES_NAME.CONNECT_CHANNELS]: connectChannels,
    [SIGN_UP_FLOW_STATES_NAME.REDIRECT]: redirectState,
  },
};
